import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, ReplaySubject } from 'rxjs';
import { DataService } from './data.service';
import { map, switchMap } from 'rxjs/operators';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { AuthService } from 'src/app/core/auth.service';
import { Router } from '@angular/router';
import { DispatcherUser } from 'src/typings/user';


@Injectable({
    providedIn: 'root'
})
export class DataEnvService {
    public envData$ = new ReplaySubject<any>(1);
    public selectedHub$ = new ReplaySubject<string | null>(1);
    public featureFlags$ = new ReplaySubject(1);

    constructor(    
        private fns: AngularFireFunctions,
        private auth: AuthService,
        private router: Router,
    ) {
    }

    public comId$ = this.envData$.pipe(
        map(envData => {
            return envData?.environmentPath;
        })
    );

    public userRoles$ = this.envData$.pipe(
        map(envData => envData?.roles)
    );

    public hubs$ = this.envData$.pipe(
        map(envData => {
            const hubs = envData?.hubs;
            if(hubs && hubs.length>0){
                this.selectedHub$.next(hubs[0]);
            }
            else{
                this.selectedHub$.next(null);
            }
            return hubs;
        })
    );

    public user$ = combineLatest([this.envData$,this.auth.user$]).pipe(
        map(([envData, user])=> {
            if(!envData || !user){
                return null;
            }
            const displayName = envData.firstName ? envData.firstName : (envData.lastName ? envData.lastName : user.email);
            let initials = '';
            if(envData.firstName && envData.lastName){
                initials = `${envData.firstName.charAt(0)}${envData.lastName.charAt(0)}`;
            }
            else if(envData.firstName){
                initials = envData.firstName.charAt(0);
            }
            else if(envData.lastName){
                initials = envData.lastName.charAt(0);
            }
            else{
                const emailUser = user.email.substring(0, user.email.indexOf('@'));
                const first = emailUser.charAt(0);
                const dotPosition = emailUser.indexOf('.');
                const second = dotPosition > 0 && dotPosition < emailUser.length-1 ? emailUser.charAt(dotPosition+1) : '';
                initials = `${first}${second}`;
            }

            return {email: user.email, firstName: envData.firstName, lastName: envData.lastName, displayName, initials};
        }
    ));

    public hasRole$(role:string, strict: boolean = false): Observable<boolean> {
        return this.userRoles$.pipe(
            map((userRoles: string[] = []) => {
                if (!userRoles || userRoles.length === 0) {
                    return !strict; //to be retrocompatible. Users with no roles are admin
                }
                return userRoles.indexOf(role) >= 0;
            })
        );
    } 
        
    public async setComFromCurrentUser(){
        const callable = this.fns.httpsCallable(`dispatcherGetCurrentEnvironmentData`);
        
        try{
            await callable({}).forEach(response => {
                const environmentPath = response?.environment?.environmentPath;
                if(!environmentPath){
                    console.log("^******** User is not authenticated ***************");
                    this.auth.signOut();
                    this.router.navigate(['/login']);
                    this.envData$.next(null);
                }
                else
                {
                    this.envData$.next(response?.environment);
                    this.featureFlags$.next(response?.featureFlags);
                }
              });
        }
        catch(err){
            console.log("^******** ERROR getting user ***************");
            this.auth.signOut();
            this.router.navigate(['/login']);
        }
    }
}
